module.exports = __webpack_public_path__ + "static/media/Sello-BCX.ab75715d.png";